import React, { useCallback, useState } from 'react'
import { Popup, CustomTable, Loading, Button } from 'src/components'

import { PageTitle } from 'src/components/PageTitle'
import { exportToCsv, formatDate, formatToBRL } from 'src/utils'
import SaleDetail from './SaleDetail'
import { Download, Filter } from 'src/assets/svg'
import { more } from 'src/assets/png'
import { useStyles } from './styles'
import { useFilterToggler } from 'src/components/CustomTable/hooks/useFilterToggler'
import { SaleDTO } from 'src/dto/sale'
import { useGetSaleList } from 'src/hooks/api/sale'
import { useSalesTableHeader } from './hooks/useSalesTableHeader'

export const Sales: React.FC = () => {
  const style = useStyles()
  const [saleData, setSaleData] = useState<SaleDTO | undefined | null>(null)
  const { filterIsActive, handleFilter } = useFilterToggler()

  const { data: salesList = [], isLoading } = useGetSaleList()

  const handleItemDetailModal = useCallback((item: SaleDTO | undefined | null) => {
    setSaleData(item)
  }, [])

  const handleClose = useCallback(() => {
    setSaleData(null)
  }, [])

  const { tableHeader } = useSalesTableHeader({ handleItemDetailModal })

  const handleExport = () => window.dispatchEvent(new CustomEvent('exportData'))

  const exportData = (currentData: any[]) => {
    const columns = {
      id: 'ID',
      data: 'DATA',
      animal: 'ANIMAL',
      preco: 'PREÇO',
      comprador: 'COMPRADOR'
    }
    const data = currentData.map((item) => ({
      ...item,
      animal: item.animais.join(', '),
      data: formatDate(item.data) || '',
      preco:
        typeof item.valorTotal === 'string'
          ? formatToBRL(parseFloat(item.valorTotal) || 0)
          : formatToBRL(item.valorTotal as number) || ''
    }))

    const fileName = 'lista_de_vendas'
    exportToCsv(data, columns, fileName)
  }

  const renderContent = () => {
    if (isLoading) return <Loading />

    return (
      <>
        <div className={style.salesContainer}>
          <CustomTable
            header={tableHeader}
            filterIsActive={filterIsActive}
            body={salesList}
            exportData={exportData}
            propertiesToFilter={['id', 'data', 'animais', 'valorTotal', 'comprador']}
            filterPlaceholder='Série, Nome, Sexo...'
          />
        </div>

        {saleData !== null && (
          <Popup title='Cadastrar Venda' className={style.salesPopup} onClose={handleClose} closeOnClickOutside={false}>
            <SaleDetail saleData={saleData} onClose={handleClose} />
          </Popup>
        )}
      </>
    )
  }

  return (
    <>
      <div className={style.salesHeader}>
        <div className={style.salesHeaderContent}>
          <PageTitle title='Lista de Vendas' />
          <div className={style.buttonContainer}>
            <Button secondary disabled={!salesList.length} onClick={handleFilter} outlined>
              <Filter className='icon' />
              FILTRAR
            </Button>

            <Button secondary onClick={handleExport} disabled={!salesList.length} outlined>
              <Download className='icon' />
              EXPORTAR
            </Button>

            <Button onClick={() => handleItemDetailModal(undefined)}>
              <img src={more} alt='Incluir' />
              CADASTRAR
            </Button>
          </div>
        </div>
      </div>
      {renderContent()}
    </>
  )
}
